import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwPhotoPickerDropdown extends Component {
  @service dynamicDialogs;

  @tracked dropdownOptions;

  choosePhotoArgs;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
  }

  openPhotoPickerDialog(instantUpload) {
    this.choosePhotoArgs = {
      theme: this.args.theme,
      url: this.args.url,
      task: this.args.task,
      selectPhoto: this.args.selectPhoto,
      titles: this.args.titles,
      instantUpload: instantUpload,
    }
    this.dynamicDialogs.openDialog('pick-photo-dialog', this.choosePhotoArgs);
  }

  @action
  addFile() {
    this.openPhotoPickerDialog(true);
  }

  @action
  openCloudPicker() {
    this.openPhotoPickerDialog(false);
  }
}
